export default __webpack_public_path__ + "static/media/bsu.149469ed.jpg";